import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/app/providers";
import { createQueryClient } from "@/app/query-client";
import { createAppRouter } from "@/app/router";
import { createAppServices } from "@/app/services";

import "./styles.css";

const queryClient = createQueryClient();
const router = createAppRouter({ queryClient, ...createAppServices() });

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element was not found");

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders router={router} />
  </StrictMode>
);
